import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_016",
  "use": "icon-su_016-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_016\"><defs><style>#icon-su_016 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_016_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_016_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M19.71,18.29l-4.64-4.64a6.71,6.71,0,1,0-1.42,1.42l4.64,4.64a1,1,0,0,0,1.42,0A1,1,0,0,0,19.71,18.29Zm-10-3.91a4.69,4.69,0,1,1,4.69-4.69A4.69,4.69,0,0,1,9.69,14.38Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol